module.exports = "/deep/ .k-popup.timepicker-filter .k-action-buttons {\n  margin-bottom: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-datatable/src/components/filters/menu/time/time.component.scss
// module id = ./libs/chassis-datatable/src/components/filters/menu/time/time.component.scss
// module chunks = main